import {useEffect} from 'react';
import {VirtuosoHandle} from 'react-virtuoso';

import {useDetectPanelVariant} from '../../Panel/hooks';
import {usePanelBankSectionsScrollContext} from '../PanelBankSectionsScrollContextProvider';
import {useVisibleSectionsContext} from './useVisibleSectionsContext';

export const useScrollToPanelBankSectionId = (
  virtuosoRef: React.MutableRefObject<VirtuosoHandle | null>
) => {
  const visibleSectionsWithRefs = useVisibleSectionsContext();

  const {scrollToPanelBankSectionId, setScrollToPanelBankSectionId} =
    usePanelBankSectionsScrollContext();
  const {isFullScreenPanelPage} = useDetectPanelVariant();
  const desiredIndex = visibleSectionsWithRefs.findIndex(
    section => section.__id__ === scrollToPanelBankSectionId
  );

  useEffect(() => {
    // setting this to avoid overwriting the scroll index when we render the panelBank
    // behind the full screen panel. we can remove this once we ship panel caching.
    if (isFullScreenPanelPage) {
      return;
    }
    // if we're just scrolling to a section at the very top of the page, no need to cut off the search bar
    if (desiredIndex <= 1) {
      setScrollToPanelBankSectionId(undefined);
      return;
    }
    if (scrollToPanelBankSectionId !== undefined && virtuosoRef.current) {
      virtuosoRef.current?.scrollToIndex({
        index: desiredIndex,
        align: 'start',
        behavior: 'auto',
      });
      setScrollToPanelBankSectionId(undefined);
    }
  }, [
    desiredIndex,
    scrollToPanelBankSectionId,
    setScrollToPanelBankSectionId,
    isFullScreenPanelPage,
    virtuosoRef,
  ]);
};
